// extracted by mini-css-extract-plugin
export default {"title":"Text_title__Ux-w0","subtitle":"Text_subtitle__ZnVW9","paragraph":"Text_paragraph__kKKQv"};